export default __webpack_public_path__ + "static/media/kybsubmitted.ba56d6f4.svg";